var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"privacy-box",attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }